//Passkey events
export const passkeyCreationStarted = 'passkeyCreationStarted';
export const passkeyCreated = 'passkeyCreated';

//User events
export const currentUserLogged = 'currentUserLogged';

//Enhanced security events
export const enhancedSecurityModalOpened = 'enhancedSecurityModalOpened';
export const enhancedSecurityToggleChanged = 'enhancedSecurityToggleChanged';
export const enhancedSecurityEnabled = 'enhancedSecurityEnabled';
export const enhancedSecurityDisabled = 'enhancedSecurityDisabled';
export const enhancedSecuritySaveFailed = 'enhancedSecuritySaveFailed';
export const enhancedSecurityMfaDeviceResetClicked = 'enhancedSecurityMfaDeviceResetClicked';

//Recovery mobile number events
export const recoveryMobileNumberSetupStarted = 'recoveryMobileNumberSetupStarted';
export const recoveryMobileNumberSetupSuccessful = 'recoveryMobileNumberSetupSuccessful';
export const recoveryMobileNumberSetupFailed = 'recoveryMobileNumberSetupFailed';
export const recoveryMobileNumberCreationStarted = 'recoveryMobileNumberCreationStarted';
export const recoveryMobileNumberEditStarted = 'recoveryMobileNumberEditStarted';
export const recoveryMobileNumberEditSuccessful = 'recoveryMobileNumberEditSuccessful';
export const recoveryMobileNumberEditFailed = 'recoveryMobileNumberEditFailed';
export const recoveryMobileNumberDeleted = 'recoveryMobileNumberDeleted';
export const recoveryMobileNumberDeletionStarted = 'recoveryMobileNumberDeletionStarted';
export const recoveryMobileNumberDeletionFailed = 'recoveryMobileNumberDeletionFailed';
export const recoveryMobileNumberVerificationFailed = 'recoveryMobileNumberVerificationFailed';
export const recoveryMobileNumberSendCodeFailed = 'recoveryMobileNumberSendCodeFailed';
export const recoveryMobileNumberResendCodeFailed = 'recoveryMobileNumberResendCodeFailed';

//Page view events
export const personalInfoPageViewed = 'personalInfoPageViewed';
export const signInSecurityPageViewed = 'signInSecurityPageViewed';
export const developerToolsPageViewed = 'developerToolsPageViewed';

//Personal Info events
export const personalInfoEditStarted = 'personalInfoEditStarted';
export const personalInfoSaved = 'personalInfoSaved';
export const personalInfoSaveFailed = 'personalInfoSaveFailed';
export const avatarEditStarted = 'avatarEditStarted';
export const avatarUploaded = 'avatarUploaded';
export const avatarUploadFailed = 'avatarUploadFailed';
export const avatarResetToDefault = 'avatarResetToDefault';
export const avatarResetFailed = 'avatarResetFailed';

//Email events
export const emailEditStarted = 'emailEditStarted';
export const emailChanged = 'emailChanged';
export const emailChangeFailed = 'emailChangeFailed';
export const emailVerificationSent = 'emailVerificationSent';
export const emailVerificationFailed = 'emailVerificationFailed';
export const recoveryEmailChanged = 'recoveryEmailChanged';
export const recoveryEmailChangeFailed = 'recoveryEmailChangeFailed';
export const emailSubscriptionOptOutClicked = 'emailSubscriptionOptOutClicked';

//Password events
export const passwordEditStarted = 'passwordEditStarted';
export const passwordChanged = 'passwordChanged';
export const passwordChangeFailed = 'passwordChangeFailed';

//Social account events
export const socialAccountConnectionStarted = 'socialAccountConnectionStarted';
export const socialAccountDisconnected = 'socialAccountDisconnected';
export const socialAccountConnectionFailed = 'socialAccountConnectionFailed';
export const socialAccountsModalOpened = 'socialAccountsModalOpened';

//Device events
export const devicesModalOpened = 'devicesModalOpened';
export const deviceApproved = 'deviceApproved';
export const deviceReported = 'deviceReported';
export const deviceDisconnected = 'deviceDisconnected';
export const deviceDisconnectionFailed = 'deviceDisconnectionFailed';
export const deviceApprovalFailed = 'deviceApprovalFailed';

//Developer Tools events
export const personalAccessTokenCreated = 'personalAccessTokenCreated';
export const personalAccessTokenDeleted = 'personalAccessTokenDeleted';
export const personalAccessTokenCreationFailed = 'personalAccessTokenCreationFailed';
export const enhancedSecuritySetupStarted = 'enhancedSecuritySetupStarted';
